module.exports = __webpack_public_path__ + "img/logo_cars_03.5ba5c940.png";